<div [id]="data.widgetId" *ngIf="data"
  [style.--widget-chart-height]="data?.chartHeight || data?.chartConfig?.chartHeight || data?.chartConfig?.height || null"
  [style.height]="data?.chartHeight || data?.chartConfig?.chartHeight || '100%'" style="width: 100%;">
</div>
